__turbopack_context__.v({
  "bulletList": "expandable-list-module__oCBvbq__bulletList",
  "listFade": "expandable-list-module__oCBvbq__listFade",
  "listItemText": "expandable-list-module__oCBvbq__listItemText",
  "root": "expandable-list-module__oCBvbq__root",
  "toggle": "expandable-list-module__oCBvbq__toggle",
  "toggleIcon": "expandable-list-module__oCBvbq__toggleIcon",
  "toggleLabel": "expandable-list-module__oCBvbq__toggleLabel",
  "visibleListWrap": "expandable-list-module__oCBvbq__visibleListWrap",
});
